export const ppaQuestionsHebrew: string[] = [
  'האם אתה מעיר לאחרים או מאשים ללא מחשבה מוקדמת ואחר כך מצטער על כך ?',
  'כאשר אחרים נעשים חסרי מנוחה, האם אתה נשאר די רגוע ?',
  'האם אתה מעלעל בלוחות זמנים של רכבות, מדריכי טלפונים, או מילונים רק לשם ההנאה שבדבר ?',
  'כאשר אתה מתבקש לקבל החלטה, האם אתה מושפע ממידת החיבה או חוסר החיבה שיש לך כלפי האישיות המעורבת ?',
  'האם בשל חשש לפגוע במישהו תימנע מלברר אתו עניין הקשור  בעבודה ?',
  'האם בעבודתך אתה מוצא עצמך  מאבד את הריכוז  כשאין סיבה הגיונית לכך? ',
  'האם אתה מעדיף להיות בעמדה שבה לא תהיה לך אחריות לקבלת החלטות?',
  'האם פעולותיך נחשבות בלתי צפויות בעיני אחרים?',
  'האם אתה בדרך כלל נוהג בהתחשבות  בדרישותיך מעובדיך, מחברים לעבודה או מחניכים?',
  'האם אנשים אחרים מעניינים אותך במידה רבה ?',
  'האם קולך חדגוני, יותר מאשר משתנה בגובה צליליו ?',
  'האם אתה בדרך כלל נותן לאחר להתחיל את השיחה ? ',
  'האם אתה בקלות מגלה עניין בשיחות של אחרים ?',
  ' כאשר חבר לעבודה  עשה לך עוול ואחר כך ריצה אותך, האם תוכל לבטוח בו שוב ?',
  'האם התנהגותך היא אימפולסיבית לעיתים קרובות?',
  'האם אתה מדבר לאט ?',
  'האם בדרך כלל אתה מתייחס בחשיבות לבטיחותך במקום עבודתך ?',
  'האם מעשים לא צפויים מטרידים אותך לעיתים ? ',
  ' אם חברתך תתמזג עם חברה אחרת האם תבין לרוחם של אלה שייפגעו מהקיצוצים  ?',
  'האם אתה חושב שתוכל לתת שיפוט מהיר ובר תוקף ?',
  'האם כישלונותיך מהעבר עדיין מדאיגים אותך ?',
  'האם אתה מוצא את עצמך פעיל יותר מהרגיל בתקופות שנמשכות ימים אחדים?',
  'האם אתה מתקומם כנגד ניסיונותיהם של אחרים להגיד לך מה לעשות ?',
  'האם בדרך כלל קשה לך "להודות ולקחת על עצמך את האשמה" ? ',
  'האם יש לך חוג מצומצם של חברים קרובים, לעומת מספר גדול של ידידים, היכרויות שטחיות?',
  ' האם אתה זקוק למאמץ תמידי כדי להתמודד בעומס העבודה? ',
  'האם לעיתים קרובות אתה שר או שורק ככה סתם להנאתך ?',
  'האם תעדיף להשתייך לקבוצה קטנה ולא לקבוצה גדולה ? ',
  'האם תעדיף לתת פקודות ולא לקבל פקודות?',
  'האם אתה נהנה לספר לאנשים על השערורייה האחרונה שארעה למכריך?',
  'האם תוכל להסכים להטלת משמעת חמורה ?',
  'האם המחשבה להתחיל משהו לגמרי מחדש תגרום לך לדאגה רבה ?',
  'האם אתה עושה מאמצים לגרום לאחרים לצחוק ולחייך?',
  'האם לדעתך קל לך לבטא את רגשותיך ?',
  'האם אתה נמנע מלהתלונן כאשר אדם אחר מאחר לפגישה ? ',
  'האם  אחרים  רואים אותך לפעמים כמי שמתקשה להיכנס לרוח הדברים  בעבודה?',
  'האם להערכתך רוב האנשים ישתפו אתך פעולה?',
  'האם תודה בטעות רק כדי "לשמור על השקט" ?',
  'האם בעיני חבריך לעבודה אתה אדם ידידותי ולבבי?',
  'האם אתה מרוצה מעבודתך רק לעתים רחוקות, אלא אם כן יש לך סיבה מיוחדת לכך?',
  ' האם בוועידות, באסיפות, בסמינרים או במפגשים, אתה מתערב בקהל?',
  'האם אתה נוקט באמצעי זהירות סבירים כדי למנוע תאונות ? ',
  'האם המחשבה על דיבור בפני אנשים גורמת לך עצבנות?',
  'אם תראה מוצר בחנות אשר ברור כי הודבק עליו בטעות מחיר נמוך ממחירו הנכון, האם תנסה להשיג אותו במחיר ההוא ?',
  'האם לעיתים קרובות אתה מרגיש שאנשים מסתכלים עליך או מדברים עליך מאחורי גבך?',
  'האם אתה "תמיד נכנס לצרות" ?',
  'האם לדעתך ישנם חברים לעבודה שאינם ידידותיים אליך ואשר פועלים נגדך ?',
  'האם אתה מעדיף להיות צופה מן הצד ולא להשתתף בפעילויות?',
  'האם אתה מוצא שקל לך להיות אובייקטיבי ?',
  'האם תתקוף עובד שכפוף לך אם עשה טעות שהרגיזה אותך ?',
  'האם אתה מסוגל "להתחיל להזיז עניינים" בפגישה או בוועידה ?',
  ' האם תלווה כסף מחברך לעבודה בתקווה שתוכל לעמוד בתשלומים ?',
  ' האם דרוש לך זמן-מה  להירגע אחרי טיפול במצב טעון-מתח בעבודה?',
  'האם אתה מחשיב את טובת כל הנוגעים בדבר יותר מאשר את היתרונות האישיים שלך?',
  'כאשר אתה מאזין להרצאה, האם לפעמים אתה מרגיש שהמרצה מתייחס אך ורק אליך ?',
  'האם "רעש חיצוני" מפריע לריכוז שלך לעיתים רחוקות?',
  'האם אתה בדרך כלל "מעודכן" בענייני יום יום ?',
  'האם אתה יכול לתכנן בביטחון ולעבוד לקראת ביצוע אירוע שיתרחש בעוד ששה חודשים ?',
  'האם בדרך כלל אתה מוצא שהפעולות של עמיתיך נובעות מכוונה כנה ואמיתית ?',
  'האם אתה נוטה להיות לא זהיר ?',
  'האם אי פעם אתה מרגיש שאתה עובד ללא מטרה ?',
  'האם אתה מתאושש במהירות משיבושים בעבודתך ?',
  'בשעה שאתה מותח ביקורת - האם באותו זמן אתה מנסה גם לעודד ?',
  'האם בדרך כלל אתה נחשב כאדם "קר" ?',
  'האם דעותיך אינן חשובות מספיק כדי לספר אותן לאנשים אחרים ?',
  'האם אתה בוטח בעצמך עד כדי כך שזה לפעמים מרגיז אנשים אחרים ?',
  'האם אתה מקפיד לעקוב אחר חפצים שלך שהשאלת לחברים לעבודה או לשותפים? ',
  'האם אתה נהנה מפעילויות שאתה בחרת אותן ?',
  'האם ישנם  רק אנשים מעטים שאתה מעריך באמת? ',
  'האם אתה פוסל אדם לחלוטין מפני שהוא מהוה מתחרה או יריב שלך בתחום כלשהו במערכת היחסים שביניכם?',
  'האם אתה מהרהר או שוקע במחשבות על קריירה שאולי החמצת?',
  'האם אתה חרד מפני התבזות בעבודה ?',
  'האם אתה תמיד אוסף דברים ש"אולי יהיה בהם שימוש"?',
  'האם תבקר פגמים ותצביע על נקודות חולשה באופיו של אדם אחר או במלאכת ידו ?',
  'האם קבוצה חרוצה ונלהבת של חברים לעבודה מעוררת בך השראה ?',
  'האם לפעמים אתה מוסר חפצים שבעצם לא שייכים לך ?',
  'האם אתה מברך אנשים ברגשנות ? ',
  'האם לעיתים קרובות אתה מהרהר בחוויות שליליות שהיו לך  בעבר בעבודה?',
  'האם לפעמים אתה נחשב תקיף בדעותיך או במעשיך ?',
  'האם אתה מקבל ביקורת בקלות וללא תרעומת ?',
  'האם אי פעם אתה מוצא את עצמך תלוש ומבולבל מהעבודה?',
  'האם אתה נוטה לקנא בחבר-לעבודה שזכה בקידום?',
  'האם אתה נוטה לדחות עשיית דברים ואז מגלה שזה מאוחר מדי ?',
  'האם אתה מעדיף להיענות לרצונותיהם של אחרים יותר מאשר ללכת בדרכך שלך ?',
  'האם אתה מוצא שזה קל לגרום לעצמך להתחיל פרויקט ?',
  'האם אתה כוסס את ציפורניך או לועס את קצה העיפרון שלך ?',
  'האם אתה "מגביר את העוצמה" של רגשותיך רק על מנת ליצור רושם ? ',
  'האם  אחרים מוצאים לעתים שקשה לדבר אתך ?',
  'האם ישנם דברים במקום העבודה שלך שמרגיזים אותך ?',
  'האם יש לך מעט נושאי התעניינות ופעילויות שהם הבחירה שלך ?',
  'האם בדרך כלל אינך מוטרד מרעשים חיצוניים, כאשר אתה מנסה לעבוד?',
  'האם אתה רואה עצמך כעובד איטי ?',
  'האם אתה יכול להיות בעל השפעה מייצבת כשאחרים נכנסים לפאניקה?',
  'האם תעצור ותבדוק אם אדם נזקק לעזרה על אף שהוא לא ביקש זאת ממך באופן ישיר?',
  'האם אהדתך נתונה בראש וראשונה למקום עבודתך, לבית ספרך, למועדונך,  לקבוצתך וכדומה?',
  'האם אתה מקיים את הבטחותיך וההסכמים שלך כאשר זה אפשרי ?',
  'האם רעש הרוח או הרחשים בבניין הטרידו אי-פעם אותך?',
  'האם אתה זהיר לגבי אנשים המבקשים ללוות ממך כסף ?',
  'האם אתה מעדיף למלא תפקיד פסיבי במועדון או בארגון אליו אתה שייך ?',
  'האם אתה הגיוני ומדעי בחשיבתך ?',
  'האם לנוער של היום ישנן יותר אפשרויות מאשר היו לדור הקודם ?',
  'האם אתה משליך דברים רק כדי לגלות שתצטרך אותם מאוחר יותר ?',
  'האם תוותר בקלות על דרך מסוימת אם תגרם לך מידה רבה של חוסר נוחיות ?',
  'האם אתה מסוגל לומר דברי-שבח בגלוי?',
  'האם רק לעיתים רחוקות אתה חושד בצעדים העסקיים של אחרים ?',
  'האם לעיתים אתה תוהה אם מישהו באמת מעוניין בטובתך במקום העבודה שלך?',
  'האם אתה דוחה אחריות מפני שאתה בספק לגבי יכולתך לשאת בה ? ',
  'האם לפעמים אתה מרגיש מוכרח לחזור על איזשהו פריט מעניין או רכילות קטנה ומשעשעת ?',
  'האם אתה נוטה לנפח תלונה שניתן להצדיקה ?',
  'האם הבעת פניך משתנה יותר מאשר קבועה ?',
  'האם בדרך כלל אתה צריך להצדיק או לתמוך בדעה שהובעה ?',
  'האם אתה מתפעל בגלוי ובכנות מיופי אצל אנשים אחרים ?',
  'האם תזדקק למאמץ ניכר כדי לשקול התנתקות ממערכת יחסים ממושכת?',
  'האם אתה מחשיב את עצמך כבעל מרץ רב ביחס שלך כלפי החיים ?',
  'האם חוסר הסכמה ישפיע על יחסך הרגיל עם אדם אחר ?',
  'האם כשלון קל מצידך מטריד אותך לעיתים רחוקות?',
  'האם לפעמים אתה מרגיש שאתה מדבר יותר מדי במקום העבודה שלך?',
  'האם אתה מחייך הרבה ?',
  'האם ניתן להשביע את רצונך בקלות ?',
  'בעת התקלות בהתנגדות ישירה האם עדיין תנסה לאחוז בדרך שלך יותר מאשר תוותר ?',
  'בהנחה שהמרחק אינו גדול מדי ,האם עדיין תעדיף לנסוע במקום ללכת ברגל ? ',
  'כאשר אתה משוחח עם אחרים האם אתה מודע להרגלך למשוך בשיער, באף, באוזן וכדומה ?',
  'האם דעתך מושפעת מהסתכלות על דברים מנקודת המבט של ניסיונותיך, משלח ידך או ההדרכה שקיבלת ?',
  'האם לעיתים קרובות אתה עושה טעויות גסות בחוסר טקט ?',
  'האם לאדם זכויות וזכויות יתר, אך ורק מתוקף היותו הבן הבכור או הבת הבכורה?',
  'האם החלטותיך מושפעות מאינטרסים אישיים ?',
  'האם אתה יכול להתלהב מ"דברים קטנים ופשוטים"?',
  'האם לעיתים תכופות אתה נוקט פעולה למרות שאתה יודע ששיפוטך הטוב יורה אחרת ?',
  'כאשר אתה בא להחליט, האם תפעל משיקולי העדפה אישית ולאו דווקא מתוך בחינת השאלות או בני האדם הנוגעים לעניין?',
  'האם רעשים מסוימים בעבודתך או במקום העבודה שלך מביאים אותך לידי עצבנות?',
  'האם אתה יכול להסתגל במהירות ולהפיק תועלת מנסיבות ומצבים חדשים למרות שהם יכולים להיות קשים ?',
  'האם נוכחות של ילדים במקום עבודתך תרגיז אותך?',
  'האם אתה יכול לראות את נקודת ראותו של האדם השני כאשר אתה רוצה בכך ?',
  'האם אתה הולך לישון מתי שאתה רוצה, יותר מאשר "לפי השעון" ?',
  'האם "החולשות הקטנות" של אחרים גורמות לך לחוסר סבלנות ?',
  'האם לעתים קרובות נראית לך עבודתך כמעמסה כבדה ?',
  'האם אתה פחות נוטה לדבר מחבריך לעבודה? ',
  'האם אתה בדרך כלל מבצע משימות באופן שיטתי ומיידי ?',
  'האם תעדיף לעזור לחבריך לטיול ולא להשאיר זאת לאחראים ?',
  'אילו התבקשת לבחור מנהל, האם תצביע בעד זה שחיבב אותך יותר מהאחרים, במקום לבחון את הישגיו של כל איש בתחומו?',
  'האם לעיתים קרובות אתה מתמקד בכישלונות העבר או בחוויות שליליות מן העבר במקום העבודה שלך?',
  'האם בקלות אתה מרגיש מאוד לא נח בסביבות לא מסודרות ?',
  'האם בדרך כלל אתה מבקר סרט או הצגה שאתה רואה או ספר שאתה קורא ?',
  'כאשר אתה מספר מקרה משעשע כלשהו, האם אתה יכול בקלות לחקות את הגינונים או המבטא באירוע המקורי ?',
  'בנושאים בהם אתה לא מומחה, האם הרעיונות שלך חשובים מספיק כדי שתספר אותם לאחרים ?',
  'האם יש לך נטייה לעשות סדר בתחומו של מישהו אחר ?',
  'האם אתה יכול לקבל תבוסה בקלות בלי ההכרח "לבלוע את אכזבתך" ?',
  'האם לעתים אתה חושב שעבודתך היא למעלה מכוחך ?',
  'האם רק פרויקטים מעטים מלהיבים אותך?',
  'האם אתה נעשה מתוסכל כאשר אינך יכול לעשות משהו במקום למצוא פעילות או שיטה חלופית ?',
  'האם לפעמים אתה בכלל לא מסוגל להיכנס לרוח הדברים ?',
  'האם לעיתים רחוקות אתה מבטא את תלונותיך ?',
  'האם אתה עובד ב"התפרצויות", יחסית לא פעיל ואחר כך פעיל בשצף קצף למשך יום יומיים ?',
  'האם כמות העבודות הלא גמורות שבידיך מפריעה לך ?',
  'האם אנשים נהנים להיות בחברתך ?',
  'האם תוכל לתת למישהו לסיים את "שתי המילים האחרונות" בתשבץ מבלי להתערב?',
  'האם אתה מביא בחשבון את יתרונותיהם של רוב האנשים ורק לעיתים רחוקות מדבר בגנותם ?',
  'האם אתה צוחק או מחייך בנקל ?',
  'האם אתה תקיף והחלטי בקול ובהתנהגות ?',
  'האם רק לעתים רחוקות אתה משתפך ? ',
  'האם ההתעניינות ושטחי הידע שלך כל כך חשובים כך שניתן זמן מועט לכל דבר אחר ?',
  'האם היית רוצה "להתחיל בפעילות חדשה" במקום שבו אתה גר ?',
  'האם היית נוקט בפעולות הכרחיות להרוג חיה כדי לשים קץ לייסוריה ?',
  'האם קל לך להירגע ?',
  'האם יש לך חרטה מועטה לגבי חוסר מזל וכישלונות העבר ? ',
  'האם עצם המחשבה על סיטואציה במקום העבודה שממנה אתה חושש ביותר, מעוררת בך תגובה?',
  'האם אתה יכול לסמוך על הכרעה של שיפוטך בנסיבות רגשיות בהן אתה מעורב ?',
  'האם אדם אחר יכול לחשוב שאתה באמת פעיל ? ',
  'האם אתה מוצא שזה קשה להתחיל במשימה שצריכה להיעשות ? ',
  'האם אי פעם אתה מרגיש לא נוח בחברת עמיתיך?',
  'האם אתה מעביר זמן רב בדאגות לא נחוצות ?',
  'במחלוקת, האם אתה מוצא שזה קשה להבין איך האדם האחר נכשל לראות את נקודת מבטך ולכן לא מסכים אתך ?',
  'האם אתה מסתדר די טוב עם הבעיות היום יומיות של העבודה ?',
  'האם אתה בדרך כלל כן עם אחרים ? ',
  'האם תעדיף "לחכות שמשהו יקרה" בניגוד לכך שתגרום זאת ? ',
  'האם אתה מבזבז יותר זמן מזה העומד לרשותך ?',
  'האם אתה יכול לקחת על עצמך "סיכון מחושב" בלי דאגה רבה מדי ? ',
  'אילו היית מעורב בתאונת רכב קלה האם באמת היית מוודא שכל נזק שגרמת יתוקן ?',
  'האם אחרים אומרים לך מה לעשות ?',
  'האם אתה מגלה סבלנות לחבריך בעוד שאחרים אתה עשוי לשפוט ביתר חומרה?',
  'האם לעיתים קרובות אתה מהרהר בנחיתות בכשרונותיך המקצועיים או ביחסיך עם חברים לעבודה ?',
  'האם חבריך לעבודה מותחים עליך ביקורת באזני אחרים ? ',
  'האם אתה נבוך מברכה  לבבית, אם  היא נעשית בפומבי?',
  'האם לעיתים קרובות אתה לא עושה משהו שאתה רוצה לעשות בגלל רצונותיהם של אנשים אחרים ?',
  'האם לפעמים אתה משוכנע בנכונות דיעותך על נושא מסוים אף אם אינך מומחה?',
  'האם לעיתים קרובות אתה מוצא את עצמך "מתפזר בבת אחת לכל הכיוונים" ?',
  'האם נראה שמכריך מכירים בערכך יותר מאשר אתה עצמך ? ',
  'האם אתה סולד מהמחשבה שתצטרך לטפל בעובד שנפצע קשה במקום העבודה שלך?',
  'לאחר שיושבו ההדורים בויכוח האם אתה ממשיך להיות לא מרוצה למשך זמן מה ?',
  'האם אתה ידידותי בקולך, בגישתך ובהבעתך ?',
  'האם סביבת העבודה שלך נראית לך מעורפלת או מרוחקת ? ',
  'האם לעיתים קרובות אתה חש צער על תלאותיהם של עובדים כושלים במקום העבודה שלך?',
  'האם "סתם מכרים" פונים אליך בבקשת עזרה או עצה בבעיותיהם האישיות ?',
  'כאשר אתה מאבד חפץ, האם עוברת בלבך המחשבה כי "מישהו בודאי גנב זאת או הניח אותו שלא במקומו" ?',
  'אילו היית חושב שמישהו חושד בך ובפעולותיך, האם היית מתמודד איתו בנושא במקום לעזוב אותו לפתור זאת בעצמו ?',
  'האם לפעמים אתה מרגיש שכישוריך בתפקיד והכשרתך פועלים נגדך ?',
  'האם יש פעמים או פרקי זמן שבהם אתה לא מאושר בעבודה ללא סיבה נראית לעין ?',
  'האם אתה רוטן הרבה על מצבים שאתה ניצב בפניהם בחיים ?',
  'האם אתה נוטה להסתיר את רגשותיך ?',
  'האם נראה לך שיש לך הרבה חברים חמים ?'
];
